import {
    DIC
} from '@/const/dic'
// import {
//     validateChinese
// } from '@/util/validate'
// import {
//     formatterTime
// } from '@/util/util'
import {
    baseUrl
} from '@/config/env';


export const setTagsOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    columnBtn: false,
    //viewBtn: true,
    menuWidth: '200',
    labelWidth: '150',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [{
            label: "用户类型",
            prop: "clientType",
            type: 'select',
            span: 13,
            placeholder: '请选择客户端类型',
            // valueDefault:"JOINS_ENGINEER",
            dicData: DIC.TAGS_CLIENT_TYPE,
            disabled: true,
            addVisdiplay: false,
            editVisdiplay: false,
       
        },
        {
            label: "商户",
            prop: "shopInfo",
            span: 13,
            addVisdiplay: false,
            editVisdiplay: false,
            hide: true,
            type: 'input',
            formsolt: true
        },
        {
            label: "工程师",
            prop: "engineerInfo",
            span: 13,
            addVisdiplay: false,
            editVisdiplay: false,
            hide: true,
            type: 'input',
            formsolt: true
        },
        {
            label: "推广员",
            prop: "promotionInfo",
            span: 13,
            addVisdiplay: false,
            editVisdiplay: false,
            hide: true,
            type: 'input',
            formsolt: true
        },
        {
            label: "店铺名称",
            prop: "shopName",
            type: 'input',
            span: 13,
            placeholder: '-',
            search: true,
            disabled: true,
            addVisdiplay: false,
            editVisdiplay: false,
            formatter: function (row, value, label, column) {
                if (row.shopName) {
                    return row.shopName
                } else {
                    row.shopName = '-'
                    return row.shopName
                }
            }
        },
        {
            label: "姓名",
            prop: "username",
            type: 'input',
            span: 13,
            search: true,
            disabled: true,
            addVisdiplay: false,
            editVisdiplay: false,
        },
        {
            label: "手机号",
            prop: "mobile",
            type: 'input',
            span: 13,
            search: true,
            disabled: true,
            addVisdiplay: false,
            editVisdiplay: false,
        },
        {
            label: "店铺地址",
            prop: "address",
            type: 'input',
            span: 13,
            addVisdiplay: false,
            editVisdiplay: false,
            formatter: function (row, value, label, column) {
                if (row.address) {
                    return row.address
                } else {
                    row.address = '-'
                    return row.address
                }
            }
        },
        {
            label: "绑定时间",
            prop: "createTime",
            type: "datetime",
            // sortable: true,
            valueFormat: "timestamp",
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "分组标签",
            prop: "labelName",
            span: 13,
            width:'250',
            type: 'select',
            formsolt: true,
            solt: true,
        },
        {
            label: "更新人",
            prop: "createBy",
            type: "input",
            hide: true,
            addVisdiplay: false,
            editVisdiplay: false,
            width: "110"
        },
    ]
};